import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

export function SuccessStoriesSection() {
    return (
        <section className="w-full bg-brand-surface py-24 px-6 md:px-12 lg:px-24 border-t border-brand-border">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                {/* Left Side: Quote */}
                <div className="space-y-6">
                    <h2 className="text-3xl md:text-5xl font-bold text-brand-text leading-tight">
                        <span className="font-serif text-4xl md:text-6xl text-brand-primary">"</span>We are both naturally positive, happy-go-getters, but when you put us together, it feels like there is nothing we can't accomplish.<span className="font-serif text-4xl md:text-6xl text-brand-primary">"</span>
                    </h2>

                    <div className="space-y-4 pt-4">
                        <p className="text-lg font-medium text-brand-muted">
                            Leslie & Thomas, married in 2025
                        </p>

                        <Button
                            size="lg"
                            className="bg-brand-primary text-brand-background hover:bg-brand-primary/90 text-base px-8 py-6 rounded-full shadow-lg font-semibold"
                        >
                            Read more stories
                        </Button>
                    </div>
                </div>

                {/* Right Side: Image */}
                <motion.div
                    className="relative h-[500px] w-full rounded-3xl overflow-hidden shadow-2xl"
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    <img
                        src="/couple_success.png"
                        alt="Leslie & Thomas"
                        className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
                    />
                </motion.div>

            </div>
        </section>
    );
}
